import Close from './Close';
import Copy from './Copy';
import DarkMode from './DarkMode';
import History from './History';
import LightMode from './LightMode';
import Menu from './Menu';
import NewChat from './NewChat';
import Popout from './Popout';
import Reload from './Reload';
import Search from './Search';
import ThumbDown from './ThumbDown';
import ThumbUp from './ThumbUp';
import ZoomIn from './ZoomIn';
import ZoomOut from './ZoomOut';

export default {
  ZoomIn,
  ZoomOut,
  Close,
  History,
  NewChat,
  Copy,
  Reload,
  ThumbDown,
  ThumbUp,
  DarkMode,
  LightMode,
  Menu,
  Search,
  Popout,
};
